import { connect } from 'react-redux';
import { createErrorBanner } from 'components/Banner';
import { closeModal } from 'components/Modal';
import { selectActiveVenueId, selectUserInfo } from 'selectors/general';

import IntegrationRequestModal from './IntegrationRequestModal';

function mapStateToProps(state, ownProps) {
  const venueId = selectActiveVenueId(state);
  const { email, firstName, lastName } = selectUserInfo(state);
  const { description, guideLink, integratorName, logoImageUrl } = ownProps;

  return {
    initialValues: {
      email,
      firstName,
      lastName,
    },
    description,
    guideLink,
    integratorName,
    logoImageUrl,
    venueId,
  };
}

const mapDispatchToProps = {
  createErrorBanner,
  handleCloseModal: closeModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(IntegrationRequestModal);
